import React, { FunctionComponent } from 'react';
import Hint from 'ui/atoms/hint';
import Translate from 'ui/atoms/translate';

const DeleteError: FunctionComponent = () => {
  return (
    <Hint variant="danger">
      <div>
        <p>
          <Translate name="dashboardIssuerInvestorDetails.deleteAccount.errors.info" />
        </p>
        <p>
          <Translate name="dashboardIssuerInvestorDetails.deleteAccount.errors.activeInvestments" />
        </p>
        <p>
          <Translate name="dashboardIssuerInvestorDetails.deleteAccount.errors.cancellation" />
        </p>
      </div>
    </Hint>
  );
};

export default DeleteError;
